const KNOWN_DOMAINS = [
    'gmail.com', 'hotmail.com', 'icloud.com', 'outlook.com', 'yahoo.com', 'live.com', 'mail.com',
    'email.com', 'me.com', 'mac.com', 'msn.com', 'aol.com', 'gmx.com', 'zoho.com', 'ymail.com',
    'protonmail.com', 'proton.me', 'yopmail.com',
    'yahoo.com.ar', 'hotmail.com.ar', 'live.com.ar', 'outlook.com.ar',
    'yahoo.es', 'hotmail.es', 'outlook.es', 'hotmail.de', 'hotmail.fr', 'hotmail.it', 'hotmail.co.uk',
    'live.com.mx', 'hotmail.com.mx', 'outlook.com.mx', 'yahoo.com.mx',
    'yahoo.com.br', 'hotmail.com.br',
    'live.cl', 'hotmail.cl', 'yahoo.cl', 'terra.cl', 'vtr.net',
    'speedy.com.ar', 'fibertel.com.ar',
]

const SUGGESTION_TARGETS = [
    'gmail.com', 'hotmail.com', 'icloud.com', 'outlook.com', 'yahoo.com', 'yahoo.com.ar',
    'hotmail.com.ar', 'live.com', 'live.com.ar', 'outlook.es', 'hotmail.es', 'mail.com',
]

const EXACT_CORRECTIONS = {
    'gmail.com.ar': 'gmail.com',
    'gmail.cl': 'gmail.com',
}

const MAX_DISTANCE = 2

function editDistance(source, target) {
    const rows = Array.from({length: source.length + 1}, () => new Array(target.length + 1).fill(0))
    for (let i = 0; i <= source.length; i++) rows[i][0] = i
    for (let j = 0; j <= target.length; j++) rows[0][j] = j

    for (let i = 1; i <= source.length; i++) {
        for (let j = 1; j <= target.length; j++) {
            const cost = source[i - 1] === target[j - 1] ? 0 : 1
            rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + cost)
        }
    }
    return rows[source.length][target.length]
}

export function suggestEmail(email) {
    if (!email) return null

    const value = String(email).trim().toLowerCase()
    const separator = value.lastIndexOf('@')
    if (separator < 1) return null

    const local = value.slice(0, separator)
    const domain = value.slice(separator + 1)
    if (!local || !domain || !domain.includes('.')) return null
    if (EXACT_CORRECTIONS[domain]) return `${local}@${EXACT_CORRECTIONS[domain]}`
    if (KNOWN_DOMAINS.includes(domain)) return null

    let closest = null
    let closestDistance = MAX_DISTANCE + 1

    for (const target of SUGGESTION_TARGETS) {
        const distance = editDistance(domain, target)
        if (distance > 0 && distance < closestDistance) {
            closestDistance = distance
            closest = target
        }
    }

    if (!closest || closestDistance > MAX_DISTANCE) return null
    return `${local}@${closest}`
}
